// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tableListSelector from 'redux/selectors/tableList';
import { Row, Col, Button, Tooltip } from 'antd';
import * as productTagAction from 'redux/actions/productTag';
import * as userSelector from 'redux/selectors/user';
import * as listActions from 'redux/actions/list';
import { WrapperTable } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddForm from './components/form';
import View from './components/view';

const Fragment = React.Fragment;

class ProductTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyCount: 0,
      formVisible: false,
      tag: null,
      openView: false
    };
  }

  componentWillUnmount() {
    this.props.unload();
  }

  toggleForm = tag => {
    this.setState({ formVisible: !this.state.formVisible, tag: tag, keyCount: this.state.keyCount + 1 });
  };

  toggleView = tag => {
    this.setState({ openView: !this.state.openView, tag: tag });
  };

  columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Allow Filtering',
      dataIndex: 'allowFiltering',
      render: value => (value ? 'Yes' : 'No')
    },
    {
      title: 'Action',
      dataIndex: 'id',
      render: (id, row) => (
        <Fragment>
          <Button type="link" onClick={() => this.toggleView(row)}>
            view
          </Button>
          <Button type="link" onClick={() => this.toggleForm(row)}>
            edit
          </Button>
        </Fragment>
      )
    }
  ];

  render() {
    const tableAction = !this.props.isUserContentCreator && (
      <Fragment>
        <Button shape="circle" onClick={() => this.toggleForm({ id: null })}>
          <Tooltip placement="top" title="Add New">
            <FontAwesomeIcon icon="plus-square" />
          </Tooltip>
        </Button>
      </Fragment>
    );

    return (
      <div>
        <Row>
          <Col span={24}>
            <WrapperTable
              title="Product Tags List"
              key={this.state.keyCount}
              filters={filters}
              columns={this.columns}
              data={this.props.listData}
              api={this.props.search}
              tableAction={tableAction}
            />
          </Col>
        </Row>
        <AddForm visible={this.state.formVisible} handleClose={() => this.toggleForm(null)} tag={this.state.tag} />
        <View visible={this.state.openView} handleClose={() => this.toggleView(null)} tag={this.state.tag} />
      </div>
    );
  }
}
const filters = [
  {
    field: 'name',
    type: 'TEXT'
  }
];

const mapDispatchToProps = {
  search: productTagAction.search,
  unload: listActions.listUnload
};

const mapStateToProps = (state, props) => {
  return {
    listData: tableListSelector.listData(state),
    isUserContentCreator: userSelector.isUserContentCreator(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductTags);
